module.exports = __webpack_public_path__ + "img/jimmy.3a43b7a.png";